const axios = require('axios');

export default {
  data () {
    return {
      handingBuy: false,

      showItemModal: false,
      showItem: null,

      showBoughtModal: false,
      boughtItem: null,

      showFailedBoughtModal: false,
      boughtErrors: null,
    };
  },

  mounted () {
    this.$eventHub.$on('bid', this.bidOnAuction);
    this.$eventHub.$on('open', this.open);
  },

  destroyed () {
    this.$eventHub.$off('bid', this.bidOnAuction);
    this.$eventHub.$off('open', this.open);
  },

  methods: {
    open (item) {
      this.showItemModal = true;
      this.showItem = null;

      this.$inertia.get(`${window.location.pathname}?highlight=${item.id}`, {}, {
        preserveState: true,
        preserveScroll: true,
        only: ['highlight'],
        onSuccess: page => {
          this.showItem = page.props.highlight;
        },
      });
    },

    bidOnAuction (auction, bid) {
      if (parseInt(bid) !== bid) {
        this.$eventHub.$emit('notification', 'warning', 'Alleen afgeronden bedragen worden geaccepteerd');
        return;
      }

      axios.post('/ajax/placebid', {amount: bid, auction_id: auction.id})
          .then((response) => {
            this.$eventHub.$emit('auctions.handlers', 'favorite', auction.id);

            if (response.data.bid.type) {
              this.$eventHub.$emit('notification', 'success', 'Uw auto bod is geplaatst!', true);
              this.$eventHub.$emit('auctions.handlers', 'autobid', auction.id, bid);
            } else {
              this.$eventHub.$emit('notification', 'success', 'Uw bod is geplaatst!', true);
            }
          })
          .catch((error) => {
            if (error.response.status === 403 || error.response.status === 401) {
              this.$eventHub.$emit('login');

              return;
            }

            if (error.response.status === 422) {
              this.$eventHub.$emit('notification', 'warning', error.response.data);

              return;
            }

            this.$eventHub.$emit('notification', 'warning', 'unknown error');
          });
    },
  },
};
